import React, { useEffect, useRef, useCallback } from 'react';
import { Link } from 'react-router-dom';
import HomeContactForm from '../components/HomeContactForm';
import { useTheme } from '../context/ThemeContext';
import busImg from '../assets/images/misc/bus.png';
import notificationGif from '../assets/images/misc/notification.gif';
import n1_1 from '../assets/images/misc/notification1-1.png';
import n1 from '../assets/images/misc/notification1.png';
import n2_1 from '../assets/images/misc/notification2-1.png';
import n2 from '../assets/images/misc/notification2.png';
import n3_1 from '../assets/images/misc/notification3-1.png';
import n3 from '../assets/images/misc/notification3.png';
import n4_1 from '../assets/images/misc/notification4-1.png';
import n4 from '../assets/images/misc/notification4.png';
import n5_1 from '../assets/images/misc/notification5-1.png';
import n5 from '../assets/images/misc/notification5.png';
import n6_1 from '../assets/images/misc/notification6-1.png';
import n7_1 from '../assets/images/misc/notification7-1.png';
import n7 from '../assets/images/misc/notification7.png';
import n8_1 from '../assets/images/misc/notification8-1.png';
import n8 from '../assets/images/misc/notification8.png';
import n9_1 from '../assets/images/misc/notification9-1.png';
import n9 from '../assets/images/misc/notification9.png';
import n10_1 from '../assets/images/misc/notification10-1.png';
import n11 from '../assets/images/misc/notification11.png';

const timelineData = [
    {
        id: 1,
        type: 'left',
        timeLabel: 'Morning 8:00AM',
        description: 'myskoolbus activates when the driver swipes an NFC card, instantly notifying parents of assigned students.',
        mainImg: n1_1,
        notification: {
            icon: n1,
            time: '8:00AM',
            text: '"Good Morning. The bus G071845 has departed from school and will reach your stop on time. Thank you."'
        }
    },
    {
        id: 2,
        type: 'right',
        text: 'Parents can plan effectively, getting timely notifications if the bus is delayed over 4 minutes'
    },
    {
        id: 3,
        type: 'left',
        timeLabel: 'Morning 8:14AM',
        mainImg: n2_1,
        notification: {
            icon: n2,
            time: '8:14AM',
            text: '"The bus G071845 would be late by 4 minutes due to heavy traffic. Sorry for the inconvenience caused. Thank you"'
        }
    },
    {
        id: 4,
        type: 'right',
        text: 'Parents get notified when the bus is 2 minutes away, preventing long waits in bad weather'
    },
    {
        id: 5,
        type: 'left',
        timeLabel: 'Morning 8:28AM',
        mainImg: n3_1,
        notification: {
            icon: n3,
            time: '8:28AM',
            text: '"Bus G071845 will reach your stop within 2 mins. Thank you."'
        }
    },
    {
        id: 6,
        type: 'right',
        text: 'When the bus arrives, a notification prompts parents and students to hurry to the bus stop'
    },
    {
        id: 7,
        type: 'left',
        timeLabel: 'Morning 8:30AM',
        mainImg: n4_1,
        description: 'Good Morning, Sorry for the delay.',
        notification: {
            icon: n4,
            time: '8:30AM',
            text: '"Bus G071845 arrived at your stop. Thank you."'
        }
    },
    {
        id: 8,
        type: 'right',
        text: 'When students flash their smart cards on the NFC device, parents receive a time-stamped notification'
    },
    {
        id: 9,
        type: 'left',
        timeLabel: 'Morning 8:50AM',
        mainImg: n5_1,
        notification: {
            icon: n5,
            time: '8:50AM',
            text: '"Your child has been safely picked up from the bus stop"'
        }
    },
    {
        id: 10,
        type: 'right',
        text: 'Students begin their secure commute while parents live track the bus route through the app'
    },
    {
        id: 11,
        type: 'left',
        timeLabel: 'Morning 9:15AM',
        mainImg: n6_1,
        notification: {
            icon: n5,
            time: '9:15AM',
            text: '"Your child was dropped off at school safely. Have a good day."'
        }
    },
    {
        id: 12,
        type: 'right',
        text: 'In the evening, parents are notified via the app about students\' extra classes or extracurricular activities'
    },
    {
        id: 13,
        type: 'left',
        timeLabel: 'Evening 4:00PM',
        mainImg: n7_1,
        notification: {
            icon: n7,
            time: '4:00PM',
            text: '"Good evening, the bus G071845 is delayed by an hour to depart from school due to the annual day practice session. Thank you."'
        }
    },
    {
        id: 14,
        type: 'right',
        text: 'After school, when students board and flash their smart cards, parents receive instant notifications'
    },
    {
        id: 15,
        type: 'left',
        timeLabel: 'Evening 4:35PM',
        mainImg: n8_1,
        notification: {
            icon: n8,
            time: '4:35PM',
            text: '"Your child has been safely picked up from school. Thank you."'
        }
    },
    {
        id: 16,
        type: 'right',
        text: 'When the school bus is ready to depart from the school, all the parents are informed again.'
    },
    {
        id: 17,
        type: 'left',
        timeLabel: 'Evening 4:48PM',
        mainImg: n9_1,
        notification: {
            icon: n9,
            time: '4:48PM',
            text: '"The bus G071845 departed from school now."'
        }
    },
    {
        id: 18,
        type: 'right',
        text: 'During the commute, parents are immediately notified of any issues, such as a breakdown'
    },
    {
        id: 19,
        type: 'left',
        timeLabel: 'Evening 5:00PM',
        mainImg: n10_1,
        notification: {
            icon: n5, // Using n5 as per original code
            time: '5:00PM',
            text: '"We are extremely sorry to inform you that the bus G071845 has suffered a breakdown. An alternative bus is on the way; your child will be arriving soon. Thank you."'
        }
    },
    {
        id: 20,
        type: 'right',
        text: 'After an alternate bus arrives, students are safely transferred, and parents are notified with new bus and driver details'
    },
    {
        id: 21,
        type: 'left',
        timeLabel: 'Evening 5:10PM',
        mainImg: n9_1, // Using n9_1 as per original code
        notification: {
            icon: n9,
            time: '5:10PM',
            text: '"The alternative bus G633393 is on the way and will be arriving soon at your bus stop."'
        }
    },
    {
        id: 22,
        type: 'right',
        text: 'Parents receive another notification when the bus is about 2 minutes from their stop'
    },
    {
        id: 23,
        type: 'left',
        timeLabel: 'Evening 5:12PM',
        mainImg: n8_1,
        notification: {
            icon: n11,
            time: '5:12PM', // Corrected from 5:10PM in small tag to match header
            text: '"The alternative bus G633393 has successfully arrived at your stop. Thank you."'
        }
    },
    {
        id: 24,
        type: 'right',
        text: 'When getting off the bus, students flash their smart cards, triggering another notification to parents'
    }
];

const TimelineItem = ({ item }) => {
    if (item.type === 'right') {
        return (
            <div className="timelinecontainer right">
                <div className="content additionalText">
                    <h4>{item.text}</h4>
                </div>
            </div>
        );
    }

    return (
        <div className="timelinecontainer left">
            <div className="content">
                <div className="description">
                    <div className="notificationTime">{item.timeLabel}</div>
                    {item.mainImg && <img src={item.mainImg} alt="notification" />}
                    {item.description && <p>{item.description}</p>}
                </div>
                {item.notification && (
                    <div className="notification">
                        <img src={item.notification.icon} alt="notification" />
                        <div>
                            <img src={notificationGif} width="30" className="notificationIcon" alt="icon" aria-hidden="true" />
                            <small>Notification {item.notification.time}</small><br />
                            <em>{item.notification.text}</em>
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
};

const Parents = () => {
    const busRef = useRef(null);
    const canvasRef = useRef(null);
    const timelineRef = useRef(null);
    const { theme } = useTheme();

    const pathAmplitude = 15;
    const pathFrequency = 0.005;

    const drawSineWave = useCallback(() => {
        const canvas = canvasRef.current;
        if (!canvas) return;
        const context = canvas.getContext('2d');

        // Clear entire canvas
        context.clearRect(0, 0, canvas.width, canvas.height);

        context.beginPath();
        context.setLineDash([10, 15]);
        context.moveTo(canvas.width / 2, 0);

        for (let y = 0; y < canvas.height; y++) {
            const x = pathAmplitude * Math.sin(pathFrequency * y) + canvas.width / 2;
            context.lineTo(x, y);
        }

        const roadColor = getComputedStyle(document.body).getPropertyValue('--road-color').trim();
        context.strokeStyle = roadColor || 'black';
        context.stroke();
    }, []);

    // Effect to handle resizing and initial setup
    useEffect(() => {
        const canvas = canvasRef.current;
        const timeline = timelineRef.current;

        if (!canvas || !timeline) return;

        const resizeObserver = new ResizeObserver((entries) => {
            for (let entry of entries) {
                const { height } = entry.contentRect;
                // Update canvas dimensions to match container
                canvas.width = window.innerWidth; // Keep full width
                canvas.height = height;
                drawSineWave();
            }
        });

        resizeObserver.observe(timeline);

        // Initial draw
        canvas.width = window.innerWidth;
        canvas.height = timeline.offsetHeight;
        drawSineWave();

        return () => {
            resizeObserver.disconnect();
        };
    }, [drawSineWave]);

    // Redraw on theme change
    useEffect(() => {
        // Slight delay to ensure CSS variables have updated
        const timeoutId = setTimeout(drawSineWave, 50);
        return () => clearTimeout(timeoutId);
    }, [theme, drawSineWave]);

    // Scroll handling separate from resize/theme logic
    useEffect(() => {
        const bus = busRef.current;
        let ticking = false;

        const calculateAngle = (y) => {
            const dx = 1;
            const dy = pathAmplitude * (Math.sin(pathFrequency * (y + dx)) - Math.sin(pathFrequency * y));
            return Math.atan2(dy, dx) * (180 / Math.PI);
        };

        const updateBusPosition = () => {
            if (!bus) return;
            const scrollTop = window.scrollY;
            const busY = scrollTop;
            // Center bus horizontally on the sine wave
            const busX = pathAmplitude * Math.sin(pathFrequency * scrollTop) + (window.innerWidth / 2) - (bus.offsetWidth / 2);
            const angle = calculateAngle(scrollTop);

            bus.style.transform = `translate(${busX}px, ${busY}px) rotate(${angle}deg)`;
            ticking = false;
        };

        const onScroll = () => {
            if (!ticking) {
                window.requestAnimationFrame(updateBusPosition);
                ticking = true;
            }
        };

        window.addEventListener('scroll', onScroll, { passive: true });
        // Initial position
        updateBusPosition();

        return () => {
            window.removeEventListener('scroll', onScroll);
        };
    }, []); // Empty dependency array = runs once on mount

    return (
        <>
            <section id="main-banner-page" className="position-relative page-header about-header parallax section-nav-smooth">
                <div className="overlay overlay-dark opacity-6"></div>
                <div className="container">
                    <div className="row">
                        <div className="col-lg-6 offset-lg-3">
                            <div className="page-titles whitecolor text-center padding_top padding_bottom">
                                <h2 className="font-bold">myskoolbus Pro</h2>
                                <h2 className="font-xlight">How it works</h2>
                            </div>
                        </div>
                    </div>
                    <div className="gradient-bg title-wrap">
                        <div className="row">
                            <div className="col-lg-12 col-md-12 whitecolor">
                                <h3 className="float-left">How it works</h3>
                                <ul className="breadcrumb top10 bottom10 float-right">
                                    <li className="breadcrumb-item hover-light"><Link to="/">Home</Link></li>
                                    <li className="breadcrumb-item hover-light">How it works</li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <div className="timeline parents-timeline" ref={timelineRef} style={{ position: 'relative' }}>
                <img
                    ref={busRef}
                    src={busImg}
                    alt="Bus"
                    className="bus"
                    id="bus"
                    aria-hidden="true"
                    style={{ display: 'block' }} // Ensure visibility handled via CSS usually but keeping safe default
                />
                <canvas ref={canvasRef} id="sineWaveCanvas" style={{ position: 'absolute', top: 0, left: 0, zIndex: -1 }}></canvas>

                <section className="padding_top padding_bottom" style={{ maxWidth: '1140px', marginLeft: 'auto', marginRight: 'auto' }}>
                    {timelineData.map(item => (
                        <TimelineItem key={item.id} item={item} />
                    ))}
                </section>
            </div>

            <section id="stayconnect" className="stay-connect-section bglight position-relative">
                <div className="container">
                    <div className="contactus-wrapp">
                        <div className="row">
                            <div className="col-md-12 col-sm-12">
                                <div className="heading-title wow fadeInUp text-center text-md-left" data-wow-delay="300ms">
                                    <h3 className="darkcolor bottom20">Stay Connected</h3>
                                </div>
                            </div>
                            <div className="col-md-12 col-sm-12">
                                <div className="getin_form wow fadeInUp" data-wow-delay="400ms">
                                    <div className="wpcf7 no-js" id="wpcf7-f22-o1" lang="en-US" dir="ltr">
                                        <div className="screen-reader-response"><p role="status" aria-live="polite" aria-atomic="true"></p> <ul></ul></div>
                                        <HomeContactForm />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
};

export default Parents;
